import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { SelectedPeerFilters } from '../../../../models/peer-filters/selected-peer-filters';
import { PeerGroupType } from '../../../../models/enum/peer-group-type';
import { NavigationService } from '../../../../services/navigation.service';
import { SelectableOption } from '../../../../models/options/selectable-option';
import { PeersService } from '../../../../services/peers.service';
import { SliderComponent } from '../../../slider/slider.component';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'dynamic-peer-group',
    templateUrl: './dynamic-peer-group.component.html',
    standalone: false,
})
export class DynamicPeerGroupComponent implements OnInit {
    dynamicFilters: SelectedPeerFilters;
    standardChevron!: HTMLElement;
    standard!: HTMLElement;

    @ViewChildren(SliderComponent)
    sliderComponents!: QueryList<SliderComponent>;

    constructor(
        private peersService: PeersService,
        private notificationService: NotificationService,
        private navigationService: NavigationService,
    ) {}

    ngOnInit() {
        this.standardChevron = document.getElementById('standard-chevron')!;
        this.standard = document.getElementById('standard-filters-body')!;

        this.dynamicFilters = this.peersService.currentFilters;
    }

    toggleSectionVisibility(event: MouseEvent) {
        const target = <HTMLInputElement>event.currentTarget;
        target.classList.add('hide');
        
        this.reInitStockSlider();

        this.standard.classList.remove('hide');
    }

    apply(closeWindow: boolean) {
        if (this.noStandardOptionsChosen()) return;

        this.peersService.setOrganisationFilters(PeerGroupType.Dynamic);
        this.notificationService.success(
            'These options have been applied to your charts',
        );

        if (closeWindow) this.close();
    }

    cancel() {
        this.peersService.resetFilters();
        this.dynamicFilters = this.peersService.currentFilters;
    }

    close() {
        this.navigationService.toggleComponentByName('PeerSelectionComponent');
    }

    noneSelected(options: SelectableOption<string>[]) {
        return !options || options.every((option) => !option.isSelected);
    }

    canChangeTab() {
        return (
            !this.noneSelected(this.dynamicFilters.dlo) &&
            !this.noneSelected(this.dynamicFilters.organisationTypes) &&
            !this.noneSelected(this.dynamicFilters.regions)
        );
    }

    noStandardOptionsChosen(): boolean {
        return (
            !this.dynamicFilters ||
            this.noneSelected(this.dynamicFilters.organisationTypes) ||
            this.noneSelected(this.dynamicFilters.regions) ||
            this.noneSelected(this.dynamicFilters.dlo)
        );
    }

    reInitStockSlider() {
        const sc = this.sliderComponents.find(
            (sliderComp) => sliderComp.model.name === '',
        );

        if (sc) {
            sc.reInitSlider();
            this.dynamicFilters.stock = sc!.model;
        }
    }
}
